// Foundations
import { BreakpointsFoundationsZiniaThemes } from './breakpoints-foundations.zinia.themes';
import { ColorsFoundationsZiniaThemes } from './colors-foundations.zinia.themes';
import { FontsAlignFoundationsZiniaThemes } from './fonts-align-foundations.zinia.themes';
import { FontSizesFoundationsZiniaThemes } from './font-sizes-foundations.zinia.themes';
import { DegreesFoundationsZiniaThemes } from './degrees-foundations.zinia.themes';
import { IconsFoundationsZiniaThemes } from './icons-foundations.zinia.themes';
import { IllustrationsFoundationsZiniaThemes } from './illustrations-foundations.zinia.themes';
import { MediaQueriesFoundationsZiniaThemes } from './media-queries-foundations.zinia.themes';
import { SpacingsFoundationsZiniaThemes } from './spacings-foundations.zinia.themes';
import { ZindexFoundationsZiniaThemes } from './zindex-foundations.zinia.themes';
import { FontsWeightFoundationsZiniaThemes } from "./fonts-weight-foundations.zinia.themes";
const FoundationsZiniaTheme = {
    ...DegreesFoundationsZiniaThemes,
    ...FontsAlignFoundationsZiniaThemes,
    ...FontsWeightFoundationsZiniaThemes,
    ...IconsFoundationsZiniaThemes,
    ...IllustrationsFoundationsZiniaThemes,
    BREAKPOINTS: BreakpointsFoundationsZiniaThemes,
    MEDIA_QUERIES: MediaQueriesFoundationsZiniaThemes,
    SIZES: FontSizesFoundationsZiniaThemes,
    SPACINGS: SpacingsFoundationsZiniaThemes,
    Z_INDEX: ZindexFoundationsZiniaThemes,
    colors: ColorsFoundationsZiniaThemes,
};
export { FoundationsZiniaTheme };
//# sourceMappingURL=index.js.map